import React from 'react';

const LinkedInSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" version="1.1" x="0px" y="0px">
    <path
      fill="currentColor"
      d="M38.9 0H2.2C1.2 0 .53.67.53 1.67v36.7c0 1 .67 1.67 1.67 1.67h36.7c1 0 1.67-.67 1.67-1.67V1.67c0-1-.67-1.67-1.67-1.67zM12.38 34.2H6.54V15h6V34.2h-.16zm-3-21.86c-1.84 0-3.5-1.5-3.5-3.5 0-1.83 1.5-3.5 3.5-3.5 1.83 0 3.5 1.5 3.5 3.5s-1.5 3.5-3.5 3.5zM34.73 34.2h-6v-9.34c0-2.17 0-5-3-5-3.18 0-3.51 2.33-3.51 4.83v9.5h-6V15.02h5.67v2.67c.83-1.5 2.67-3 5.67-3 6 0 7.17 4 7.17 9.18V34.2z"
    />
  </svg>
);

export default LinkedInSvg;
